import translations from '../translations/translations.json';

export const translate = (key, selectedLanguage) => {
    return translations[selectedLanguage][key] || key;
};
